import { attr, hasMany, type SyncHasMany } from '@ember-data/model';
import type FlowQuestionnaire from 'garaje/models/flow-questionnaire';
import UserDocumentTemplateConfigurableModel from 'garaje/models/user-document-template-configurable';

export default class AbstractFlowModel extends UserDocumentTemplateConfigurableModel {
  @attr('string', { defaultValue: '' }) declare name: string;

  /**
   * intermediate relationship to enable a many-to-many use case between `Flow` and `Questionnaire`
   */
  @hasMany('flow-questionnaire', { async: false, inverse: 'flow', as: 'abstract/abstract-flow' })
  declare flowQuestionnaires: SyncHasMany<FlowQuestionnaire>;
}
